import { motion } from "framer-motion";
import { Star, Clock, MapPin } from "lucide-react";

const TrustBar = () => {
  return (
    <section className="bg-secondary/50 border-y border-border/50 py-4">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
          className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm"
        >
          <div className="flex items-center gap-2 text-foreground">
            <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" />
            <span className="font-semibold">4.9 / 5</span>
            <span className="text-muted-foreground">rahulolu klientidelt</span>
          </div>
          
          <div className="hidden md:block w-px h-4 bg-border" />
          
          <div className="flex items-center gap-2 text-foreground">
            <Clock className="w-4 h-4 text-primary" />
            <span className="text-muted-foreground">Kiire vastus</span>
            <span className="font-semibold">24h jooksul</span>
          </div>
          
          <div className="hidden md:block w-px h-4 bg-border" />
          
          <div className="flex items-center gap-2 text-foreground">
            <MapPin className="w-4 h-4 text-primary" />
            <span className="text-muted-foreground">Teenindame</span>
            <span className="font-semibold">üle Eesti</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustBar;
